import { AsyncPipe } from "@angular/common";
import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { DatepickerIntervalComponent } from "@components/datepicker-interval/datepicker-interval.component";
import { InputComponent } from "@components/input/input.component";
import { SubmitButtonComponent } from "@components/submit-button/submit-button.component";
import { Observable, Subject, merge, of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { BusyService } from "~app/common/components/busy/busy.service";
import { DateUtils } from "~app/common/utils/date-utils";
import { ISandningsloggSearchModel, SandningsloggItemModel } from "../../produktion.models";
import { SandningsloggTexts } from "../sandningslogg.texts";
import { SearchResultComponent } from "../search-result/search-result.component";
import { SandningsloggSearchService } from "./sandningslogg-search.service";

@Component({
    selector: "rask-search-panel",
    templateUrl: "./search-panel.component.html",
    styleUrls: ["./search-panel.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        InputComponent,
        DatepickerIntervalComponent,
        SubmitButtonComponent,
        SearchResultComponent,
        AsyncPipe
    ]
})
export class SearchPanelComponent implements OnInit {
    form: UntypedFormGroup;
    searchParms: ISandningsloggSearchModel;
    texts = SandningsloggTexts.texts;

    protected searchResult$: Observable<SandningsloggItemModel[]>;

    private readonly busyService = inject(BusyService);
    private readonly formBuilder = inject(UntypedFormBuilder);
    private readonly sandningsloggService = inject(SandningsloggSearchService);
    private readonly searchSrc = new Subject<void>();

    getEndDate() {
        if (this.searchParms.tom) {
            return DateUtils.formatDateString(this.searchParms.tom, DateUtils.dateformat);
        } else {
            return null;
        }
    }

    getStartDate(): string {
        if (this.searchParms.from) {
            return DateUtils.formatDateString(this.searchParms.from, DateUtils.dateformat);
        } else {
            return null;
        }
    }

    ngOnInit(): void {
        const fomDate = new Date();
        const tomDate = new Date();
        this.searchParms = {
            sokText: "",
            from: DateUtils.formatDateString(fomDate, DateUtils.dateformat),
            tom: DateUtils.formatDateString(tomDate, DateUtils.dateformat)
        };
        this.form = this.formBuilder.group(this.searchParms);

        const search$ = this.searchSrc.pipe(
            switchMap(() => this.search())
        );

        this.searchResult$ = merge(of([]), search$);
    }

    search() {
        this.mapFromForm();
        return this.busyService.addWork(this.sandningsloggService.search(this.searchParms));
    }

    searchClick = () => {
        this.searchSrc.next();
    };

    setFrom = (date: any) => {
        if (date) {
            this.searchParms.from = DateUtils.formatDateString(date, DateUtils.dateformat);
        } else {
            this.searchParms.from = "";
        }
    };

    setTom = (date: any) => {
        if (date) {
            this.searchParms.tom = DateUtils.formatDateString(date, DateUtils.dateformat);
        } else {
            this.searchParms.tom = "";
        }
    };

    private mapFromForm() {
        this.searchParms.sokText = this.form.get("sokText").value;
    }
}
